import { render, staticRenderFns } from "./price-block.vue?vue&type=template&id=5512efd1&"
import script from "./price-block.vue?vue&type=script&lang=js&"
export * from "./price-block.vue?vue&type=script&lang=js&"
import style0 from "./price-block.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports